import React from "react";
import SyncLoader from "react-spinners/SyncLoader";
import { StyledSpinner } from "./styles";
const Spinner = ({ color }) => {
  return (
    <SyncLoader
      color={color != null ? color : "white"}
      cssOverride={StyledSpinner}
    ></SyncLoader>
  );
};

export default Spinner;
